import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMagnifyingGlass2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconMagnifyingGlass2"><Path d="M2.96423 11C2.96423 6.56201 6.56194 2.96429 10.9999 2.96429C15.438 2.96429 19.0357 6.56201 19.0357 11C19.0357 13.0391 18.2762 14.9007 17.0247 16.3176L20.8536 20.1465C21.0489 20.3417 21.0489 20.6583 20.8536 20.8536C20.6583 21.0488 20.3418 21.0488 20.1465 20.8536L16.3176 17.0247C14.9008 18.2762 13.039 19.0357 10.9999 19.0357C6.56194 19.0357 2.96423 15.438 2.96423 11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMagnifyingGlass2;
